/*
 *
 * DisputeEntryModal
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 08-Apr-2026
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.disputeUci.entryModal.title'
      defaultMessage='Accedi al Portale Esercenti'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.disputeUci.entryModal.description'
      defaultMessage='La gestione delle dispute non è ancora disponibile sul nuovo Merchant Portal UniCredit. Per gestire le tue dispute, clicca su "Continua" e verrai reindirizzato alla sezione Dispute del precedente Portale Esercenti. Potrai accedervi utilizzando le credenziali già in tuo possesso, fornite dalla Banca al momento della sottoscrizione del contratto in Agenzia.'
    />
  ),
  continueButton: (
    <PortalMessage
      id='t.app.continue'
      defaultMessage='Continua'
    />
  )
}

export default formattedMessage
